import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import { MenuLabel } from "frontend/ui-components/dropdown-menu/label/label";
import { TimerIcon, VotingIcon } from "frontend/app-header/right-header/icons";
import { Menu, MenuItem } from "frontend/ui-components/dropdown-menu/dropdown-menu";
import styles from "./right-header.module.css";
import { memo, useRef } from "react";
import { useAtom, useAtomValue } from "jotai";
import { useTimer } from "frontend/hooks/use-timer";
import { SidepanelType, sidePanelType, syncServiceAtom } from "state-atoms";
import { useHeaderContext } from "frontend/context/header-context";
import { TimerCIM } from "frontend/canvas-designer-new/timer/timer";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

const Trigger = memo(() => {
  return (
    <HeaderActionButton className={styles.actionIcon}>
      <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.10156 7.49988V14.4048C1.10156 14.4812 1.16546 14.5407 1.24761 14.5407H13.1853"
          stroke="#1E1E1E"
          strokeMiterlimit="10"
        />
        <path
          d="M9.8418 2.42981H12.4695C12.5374 2.42981 12.6052 2.47212 12.6246 2.53136L14 6.00012"
          stroke="#1E1E1E"
          strokeMiterlimit="10"
        />
        <path
          d="M1.05664 7.57187L2.69584 2.59707C2.71257 2.53703 2.77111 2.49414 2.82966 2.49414H5.27173"
          stroke="#1E1E1E"
          strokeMiterlimit="10"
        />
        <path d="M11.1605 4.83398H4.39355" stroke="#1E1E1E" strokeMiterlimit="10" strokeLinecap="round" />
        <path
          d="M5.36328 4.95216L5.46023 1.03385C5.46023 1.03385 5.47962 1 5.49901 1H10.1137C10.1137 1 10.1622 1.02539 10.1525 1.05078L10.1913 4.80829"
          stroke="#1E1E1E"
          strokeMiterlimit="10"
        />
        <path
          d="M15.7538 15.3873C18.3145 15.3873 20.3904 13.3034 20.3904 10.7327C20.3904 8.16205 18.3145 6.07812 15.7538 6.07812C13.1931 6.07812 11.1172 8.16205 11.1172 10.7327C11.1172 13.3034 13.1931 15.3873 15.7538 15.3873Z"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7529 7.93982V10.7326L17.6076 11.6635"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line x1="1.09961" y1="7.5" x2="12.0996" y2="7.5" stroke="#1E1E1E" strokeLinecap="round" />
      </svg>
    </HeaderActionButton>
  );
});

Trigger.displayName = "Trigger";

export const TimerVotingMenu = memo(() => {
  const [openedSidePanel, setOpenedSidePanel] = useAtom(sidePanelType);
  const syncService = useAtomValue(syncServiceAtom);
  const timer = useTimer(syncService);
  const isTimerRunning = timer.config.isRunning;
  const { setVotingOpen } = useHeaderContext();
  const timerButtonRef = useRef<HTMLButtonElement>(null);
  const iconRef = useRef<HTMLDivElement>(null);
  const iconHover = useHover(iconRef);

  return (
    <>
      <Menu
        label={
          <div className={styles.timerVotingMenuLabel} ref={iconRef}>
            <Trigger />
            {isTimerRunning && (
              <div className={styles.timerVotingMenuLabelText}>
                {timer.minutesString}:{timer.secondsString}
              </div>
            )}
            {iconHover && (
              <Tooltip
                design="monday"
                label={"Voting & Timer"}
                relativeTo={iconRef}
                side={"bottom"}
                customStyle={{ borderRadius: 3 }}
              />
            )}
          </div>
        }
        className={styles.menu}
      >
        <MenuItem
          ref={timerButtonRef}
          label={<MenuLabel icon={<TimerIcon />} label="Timer" />}
          onClick={() => {
            if (openedSidePanel == SidepanelType.timer) {
              setOpenedSidePanel(SidepanelType.none);
            } else {
              setOpenedSidePanel(SidepanelType.timer);
            }
          }}
        />
        <MenuItem
          label={<MenuLabel icon={<VotingIcon />} label="Voting" />}
          onClick={() => {
            setOpenedSidePanel(SidepanelType.voting);
            setVotingOpen(true);
          }}
        />
      </Menu>
      <TimerCIM syncService={syncService} isReadOnly={false} />
    </>
  );
});

TimerVotingMenu.displayName = "TimerVotingMenu";
